import { render, staticRenderFns } from "./ResultsPerPage.vue?vue&type=template&id=7fc44722&scoped=true&"
import script from "./ResultsPerPage.vue?vue&type=script&lang=js&"
export * from "./ResultsPerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc44722",
  null
  
)

export default component.exports